export type Lang = "ru" | "uz";

export const dict: Record<Lang, Record<string, string>> = {
  ru: {
    badge: "AI в Telegram",
    h1_a: "Инструмент всегда под рукой",
    h1_b: "в Telegram",
    subtitle:
      "Преимущества нашего сервиса: быстрый отклик, надёжная инфраструктура, защита данных и адаптивный интерфейс.",
    live_chat: "Чат",
    placeholder: "Напишите…",
    btn_send: "Отправить",
    right_title: "Возможности GPT-5",
    right_p: "Современная модель с мультимодальностью, инструментами и контекстом.",
    li1: "Глубокие ответы и сложные рассуждения",
    li2: "Код, аналитика, документы и таблицы",
    li3: "Изображения: описание, анализ, генерация",
    li4: "Решает проблемы по запросу",
    li5: "Понимает и отвечает почти на каждый запрос",
    footer: "Все права защищены",
    hello: "Привет! Это GPT-WebApp. Чем помочь?",
    welcome: "Привет,",

    // NEW
    nav_chat: "Чат",
    nav_my: "Моя галерея",
    nav_public: "Общая галерея",
    nav_generate: "Генерация",

    gallery_title: "Галерея",
    open_in_tg: "Открыть в Telegram",
    my_empty: "Чтобы видеть свои изображения, откройте мини-приложение в Telegram.",
    loading: "Загрузка…",
    empty: "Пока пусто.",
    no_more: "Больше ничего нет",
    copy_prompt: "Скопировать промпт",
    close: "Закрыть",
    my_gallery: "Моя галерея",
    share_gallery: "Галерея",
    open_preview: "Открыть превью",

    public_title: "Лента генераций",
    search_placeholder: "Поиск по промпту…",
    sort_new: "Новые",
    sort_top: "Топ (лайки)",
    user_anon: "Пользователь",

    back_to_gallery: "← Моя галерея",
    img_not_found: "Изображение не найдено или недоступно.",
    try_in_app: "Попробовать в приложении",
    open_public: "Открыть общую галерею",
    share_hint: "Поделиться: скопируйте ссылку из панели шаринга на карточке в галерее.",
  },
  uz: {
    badge: "Telegram’da AI",
    h1_a: "Har doim qo‘lda bo‘lgan vosita",
    h1_b: "Telegram’da",
    subtitle:
      "Xizmat afzalliklari: chaqqon javob, ishonchli infratuzilma, ma’lumotlar himoyasi va moslashuvchan interfeys.",
    live_chat: "Jonli chat",
    placeholder: "Yozing…",
    btn_send: "Yuborish",
    right_title: "GPT-5 imkoniyatlari",
    right_p: "Zamonaviy model: multimodal, vositalar va kontekstni tushunish.",
    li1: "Chuqur javoblar va murakkab mulohazalar",
    li2: "Kod, analitika, hujjatlar va jadvallar",
    li3: "Rasmlar: tavsif, tahlil, generatsiya",
    li4: "So‘rov bo‘yicha muammolarni hal qiladi",
    li5: "Deyarli har qanday so‘rovga javob beradi",
    footer: "Barcha huquqlar himoyalangan",
    hello: "Assalomu alaykum! Bu GPT-WebApp. Qanday yordam bera olaman?",
    welcome: "Salom,",

    // NEW
    nav_chat: "Chat",
    nav_my: "Mening galereyam",
    nav_public: "Umumiy galereya",
    nav_generate: "Generatsiya",

    gallery_title: "Galereya",
    open_in_tg: "Telegram’da ochish",
    my_empty: "Rasmlaringizni ko‘rish uchun Telegram mini-ilovasini oching.",
    loading: "Yuklanmoqda…",
    empty: "Hozircha bo‘sh.",
    no_more: "Boshqa yo‘q",
    copy_prompt: "Promptni nusxalash",
    close: "Yopish",
    my_gallery: "Mening galereyam",
    share_gallery: "Galereya",
    open_preview: "Oldindan ko‘rish",

    public_title: "Ishlar ❤️",
    search_placeholder: "Prompt bo‘yicha qidirish…",
    sort_new: "Yangi",
    sort_top: "Top (layklar)",
    user_anon: "Foydalanuvchi",

    back_to_gallery: "← Mening galereyam",
    img_not_found: "Rasm topilmadi yoki mavjud emas.",
    try_in_app: "Ilovada sinab ko‘rish",
    open_public: "Umumiy galereyani ochish",
    share_hint: "Ulashish: galereyadagi karta panelidan havolani nusxalang.",
  },
};

export function getInitialLang(code?: string | null): Lang {
  const saved = localStorage.getItem("lang") as Lang | null;
  if (saved === "ru" || saved === "uz") return saved;
  if (code?.startsWith("uz")) return "uz";
  return "ru";
}
